import type { Variants } from 'framer-motion';

// Shared scroll-reveal presets used across About / Community so the
// "gallery curated by mission control" pacing stays consistent: a quiet
// fade + small upward drift, triggered once as each block enters view,
// with an optional stagger for grids/lists of children.
export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

export const staggerContainer = (staggerChildren = 0.08): Variants => ({
  hidden: {},
  show: {
    transition: { staggerChildren, delayChildren: 0.04 },
  },
});

// Viewport options shared by whileInView usage: trigger once, slightly
// before the block is fully on screen so the reveal feels anticipatory
// rather than late.
export const revealViewport = { once: true, margin: '-80px 0px -80px 0px' } as const;
